import { downgradeComponent } from '@angular/upgrade/static';
import angular from 'angular';
import { CreateTaskModalComponent } from '../modals/create-task-modal/create-task-modal.component';

angular
  .module('common')
  .directive(
    'coCreateTaskModal',
    downgradeComponent({ component: CreateTaskModalComponent })
  );
